import React, { useEffect, useRef, useState } from 'react';
import StemCurveCard from '../ForestDetails/StemCurvesCard';
import axios from "axios";
import { Access, hasAccess } from '../Helper/Helper';
import useToken from '../App/useToken';

export default function PotreeViewer({selectedBagfile, renderPotree }) {
  const iframeRef = useRef(null);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [forestdata, setForestdata] = useState([])
  const [annotationSelected, setAnnotationSelected] = useState("")
  const {getCustomer } = useToken()
  const customer = getCustomer()
  const itemSelected = selectedBagfile
    ? `The item ${selectedBagfile.name} has not finished its conversion yet and can't be viewed in 3D`
    : 'Please select an item to view in 3D';
  const reduceTreedata = (treeDataFeatures) => {
    // Start with initial accumulator with mutable arrays
    const firstRowFull = {
      "Alias": '',
      "ID": "",
      "x": "",
      "y": "",
      "DBH": "",
      "volume": "",
      "height": "",
      "lon": "",
      "lat": "",
      "elev": "",
      "type": "",
      "method": ""
    };
  
    const acc = {
      Full: [firstRowFull],
    };
  
    treeDataFeatures.forEach(({ properties }) => {
      // Skip if properties is missing or DBH is not a number
      if (!properties || typeof properties.DBH !== 'number') return;
  
      const dbh = Number(properties.DBH.toFixed(3));
      const volume = properties.volume ? Number(properties.volume.toFixed(3)) : 0;
      const height = properties.height ? Number(properties.height.toFixed(3)) : 0;
  
        acc.Full.push({
          "Alias": "",
          "ID": properties.ID,
          "x": properties.x,
          "y": properties.y,
          "DBH": dbh,
          "volume": volume,
          "height": height,
          "lon": properties.lon || 0.0,
          "lat": properties.lat || 0.0,
          "elev": properties.elev || 0,
          "type": properties.type || "",
          "method": properties.method || ""
        });
    });
  
    return acc;
  };
  const getForestdata = () => {
    if(renderPotree &&
      selectedBagfile &&
      selectedBagfile.processState &&
      selectedBagfile.processState.includes("Finished")) {

      var formData = new FormData();
        var token = sessionStorage.getItem("token")
        // // console.log(props.selectedBagfile._id)
        formData.append("token", token);
        formData.append("id", selectedBagfile._id);
      var config = {
                method: "post",
                url: "api/forestdata",
                data: formData,
      };
      console.log("Fetching data")
      axios(config)
      .then(response => 
      {    
        // console.log(response.data)
        const fetchedData = response.data

        if(fetchedData.forestdata && fetchedData.forestdata.treeData){
          // console.log(fetchedData.forestdata)
          var tmp = reduceTreedata(fetchedData.forestdata.treeData.features)
          setForestdata(tmp.Full)
        } else if(fetchedData.TreeData) {
          setForestdata(fetchedData.TreeData.reduce(
              (acc, { DBH, volume, height, ID, x, y, lon, lat, elev, type, method }) => ({                       
                  Full: [...acc.Full, {
                      "ID": ID,
                      "x": x, 
                      "y": y, 
                      "DBH": Number(DBH.toFixed(3)), 
                      "volume": Number(volume.toFixed(3)), 
                      "height": Number(height.toFixed(3)), 
                      "lon": lon ? lon : 0.00,
                      "lat": lat ? lat : 0.00,
                      "elev": elev ? elev : 0,
                      // "heightRaw": heightRaw ? heightRaw : 0, //# Estimated as the difference between smallest and largest height
                      "type": type ? type : "",
                      "method": method ? method : ""
                  } ]
              }),
              { Full: []}
          ))
        }
        else {
          setForestdata([])
        }
      })
        .catch(error => {
          setForestdata([])
        })  

    }
  }
  // Handle messages from iframe
  useEffect(() => {
    const handleMessage = (event) => {
      const { type, id, msg } = event.data || {};
      if (type === "ANNOTATION_CLICKED") {
        // console.log("Annotation clicked:", id);
        if(id){
          setAnnotationSelected(id)
        }
      }
      if (type === "IFRAME_LOG") {
        // console.log("IFRAME:", msg);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Load and patch Potree HTML
  useEffect(() => {
    getForestdata()

    const fetchAndPatchHtml = async () => {
      if (
        renderPotree &&
        selectedBagfile &&
        selectedBagfile.processState &&
        selectedBagfile.processState.includes("Finished")
      ) {
        const htmlPath = `potree/app-mounted-file-storage/customers/${selectedBagfile.customerId}/potree_files/${selectedBagfile.name}.html`;
        const response = await fetch(htmlPath);
        let html = await response.text();
        const basePath = new URL(htmlPath, window.location.href).href;

        // 1. Insert <base> for correct relative paths
        html = html.replace('<head>', `<head><base href="${basePath}">`);

        // 2. Patch the annotation logic
        html = html.replace(
          /annotationData\.forEach\([\s\S]+?Trees\.visible = false;/,
          `
          annotationData.forEach(an => {
            if (an.ID && (an.DBH !== -1 || an.volume !== -1) && an.DBH !== null) {
              let description = an.DBH ? "DBH: " + precisionRoundMod(an.DBH, 2) : "Only volume exists";
              let pos = [an.x, an.y, an.z];
              let norm = Math.sqrt(an.x * an.x + an.y * an.y) + 0.001;
              let dx = -an.x / norm;
              let dy = -an.y / norm;

              let annotation = new Potree.Annotation({
                  position: pos,
                  title: an.ID,
                  description: description,
                  cameraTarget: pos,
                  cameraPosition: [pos[0] + dx * 10, pos[1] + dy * 10, pos[2] + 10]
              });
              Trees.add(annotation);
            }
          });
          function iframeLog(msg) {
            window.parent.postMessage({ type: "IFRAME_LOG", msg }, "*");
          }
          Trees.visible = false;
          // console.log(Trees)
          Trees.traverse(anno => {
              // console.log(anno)
              // iframeLog("Adding click handler to annotation: " + anno.title);
              anno.domElement.on('click', () => {
                // iframeLog("Annotation clicked: " + anno.title);
                window.parent.postMessage(
                  { type: "ANNOTATION_CLICKED", id: anno.title },
                  "*"
                );
              });
            });
          
          window.addEventListener("message", event => {
            iframeLog("Received message from parent: " + JSON.stringify(event.data));
            if (event.data?.type === "CENTER_ON_ANNOTATION") {
              const match = Trees.children.find(a => a.title === event.data.id);
              if (match) {
                if (match.hasView?.()) {
                  match.clickTitle();
                } else {
                  viewer.scene.view.position.copy(match.position);
                  viewer.scene.view.lookAt(match.position);
                }
              }
            }
          });
          `
        );


        // 4. Create blob and set iframe
        const blob = new Blob([html], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        setIframeUrl(url);

        return () => URL.revokeObjectURL(url); // Clean up blob
      }
    };

  fetchAndPatchHtml();
}, [renderPotree, selectedBagfile]);

  // Send message to iframe
  const centerOnAnnotation = (id) => {
    if(id){
      iframeRef.current?.contentWindow?.postMessage(
        { type: "CENTER_ON_ANNOTATION", id },
        "*"
      );
      setAnnotationSelected(id)
    }
  };

  const view =
    iframeUrl ? (
      <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
        <div style={{width: "30%", position:"absolute", right:"0", zIndex:"100"}}>
          {forestdata && hasAccess(customer, Access.STEM_CURVE.number) && <StemCurveCard items={forestdata} selectedFlight={selectedBagfile} height='100%' isPotree={true} annotationSelected={annotationSelected} centerOnAnnotation={centerOnAnnotation}/> }

        </div>
        <iframe
          ref={iframeRef}
          src={iframeUrl}
          width="100%"
          height="100%"
          style={{ border: "none", position: "relative" }}
          title="Potree Viewer"
        />
      </div>
    ) : (
      <h2>{itemSelected}</h2>
    );

  return view;
}



